import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import messages from "../../../assets/locale/messages";
import Modal from "../../../components/Modal";
import {
  BlockAccRedBgIcon,
  UnblockAccBlueBgIcon
} from "../../../utils/Icons";
import {
  blockImporterRequest,
  unblockImporterRequest
} from "../../../store/Users/actions";

const BlockUnblockImporter = ({ open, closeModal, importerInfo }) => {
  const lang = useSelector((state) => state.locale.lang);
  const dispatch = useDispatch();

  const {
    users: {
      importersDetails: {
        blockBtn,
        unblockBtn,
        blockImporter,
        unblockImporter
      }
    },
    shared
  } = messages[lang];

  const handleConfirm = () => {
    dispatch(
      importerInfo.isBlockModal
        ? blockImporterRequest({
            data: {
              id: importerInfo.id
            }
          })
        : unblockImporterRequest({
            data: {
              id: importerInfo.id
            }
          })
    );
    closeModal();
  };

  const blockUnblockImporterContent = () => {
    return (
      <div className="delete-category-container d-flex flex-column justify-content-center align-items-center">
        {importerInfo.isBlockModal ? (
          <BlockAccRedBgIcon />
        ) : (
          <UnblockAccBlueBgIcon />
        )}
        <div className="delete-category-content mt-2 d-flex flex-column justify-content-center align-items-center text-center">
          <Typography className="fsize-18 fweight-600 title-color">
            {`${
              importerInfo.isBlockModal
                ? blockImporter.content
                : unblockImporter.content
            } "${importerInfo.name}" !`}
          </Typography>
          <Typography className="text-secondary fsize-14 mt-2 fweight-400">
            {importerInfo.isBlockModal
              ? blockImporter.confirmationContent
              : unblockImporter.confirmationContent}
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={open}
      handleConfirm={handleConfirm}
      handleClose={closeModal}
      isContentText={false}
      content={blockUnblockImporterContent()}
      hasActions={true}
      confirmBtnTxt={shared.confirm}
      cancelBtnTxt={shared.cancel}
      handleCancel={closeModal}
      showCloseIcon
      title
      confirmBtnClass={
        importerInfo.isBlockModal
          ? "danger-btn border-radius-12 ps-5 pe-5"
          : "primary-btn border-radius-12 ps-5 pe-5"
      }
      cancelBtnClass="text-secondary border-radius-12 ps-5 pe-5"
      maxWidth={"xs"}
    />
  );
};

export default BlockUnblockImporter;

BlockUnblockImporter.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  importerInfo: PropTypes.object.isRequired
};
